<template>
    <li class="tyn-appbar-item dropdown d-inline-flex d-sm-none">
        <a class="tyn-appbar-link dropdown-toggle" data-bs-toggle="dropdown" href="#" data-bs-offset="0,10">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-fill" viewBox="0 0 16 16">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z" />
            </svg>
            <span class="d-none">Menu</span>
        </a>
        <div class="dropdown-menu dropdown-menu-auto dropdown-menu-end">
            <ul class="tyn-list-links">
                <li>
                    <h6 class="tyn-list-links-heading">Quick Links</h6>
                </li>
                <li v-for="(item,index) in lstLink" :key="index">
                    <router-link :to="item.to" >
                        <div class="tyn-appbar-link">
                            <template v-if="item.img">
                                <img class="img-icone" :class="(item.class?item.class:'')" :src="item.img" :alt="item.name">
                            </template>
                            <template v-if="item.icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-database-up" viewBox="0 0 16 16" v-html="item.icon">
                                </svg>
                            </template>
                        </div>

                        <span>{{item.name}}</span>
                    </router-link>
                </li>

            </ul>
        </div>
    </li>

</template>

<script>
    export default {
        name: 'QuickLinks',
        components: {},
        props: {
            lstLink: Array,
        },
        computed: {

        },
        data: function () {
            return {
            }
        },
        methods: {

        },
        mounted: function () {

        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .img-icone {
        max-width: 20px;
    }

    .invert {
        filter: invert(80%);
    }

    [data-bs-theme="dark"] .invert {
        filter: none;
    }
</style>

